module.exports = __webpack_public_path__ + "img/qrcode.a2635db1.png";